(() => {
  const mvText=window.MontevieraText || (value=>value);
  const isBg=document.documentElement.lang.toLowerCase().startsWith("bg");
  const ISO_CODES = `AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW`.split(/\s+/);
  const ALIASES = {
    'democratic republic of the congo': 'cd',
    'congo democratic republic of the': 'cd',
    'dr congo': 'cd',
    'republic of the congo': 'cg',
    'congo': 'cg',
    'east timor': 'tl',
    'kosovo': 'xk',
    'sao tome and principe': 'st',
    usa: 'us',
    'united states of america': 'us',
    uk: 'gb',
    'saint kitts and nevis': 'kn',
    'saint vincent and the grenadines': 'vc',
    'saint lucia': 'lc',
    'saint barthelemy': 'bl',
    'saint martin': 'mf',
    'saint pierre and miquelon': 'pm',
    'saint helena': 'sh',
    'сейнт китс и невис': 'kn',
    'сейнт винсент и гренадини': 'vc',
    'сейнт лусия': 'lc',
    'great britain': 'gb',
    'south korea': 'kr',
    'north korea': 'kp',
    russia: 'ru',
    'czech republic': 'cz',
    turkey: 'tr',
    turkiye: 'tr',
    'ivory coast': 'ci',
    'cape verde': 'cv',
    swaziland: 'sz',
    'vatican city': 'va',
    macedonia: 'mk',
    'north macedonia': 'mk',
    palestine: 'ps',
    laos: 'la',
    moldova: 'md',
    bolivia: 'bo',
    venezuela: 've',
    brunei: 'bn'
  };
  const normalize = value => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^\p{L}\p{N} ]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const COUNTRY_CODES = (() => {
    const map = new Map();
    if (Intl?.DisplayNames) {
      try {
        for (const locale of new Set(['en','bg','de','fr','it',document.documentElement.lang || 'en'])) {
        const names = new Intl.DisplayNames([locale], { type: 'region' });
        ISO_CODES.forEach(code => {
          const name = names.of(code);
          if (name) map.set(normalize(name), code.toLowerCase());
        });
        }
      } catch (_) {}
    }
    const localizedCountries = {"България":"bg","Румъния":"ro","Испания":"es","Германия":"de","Португалия":"pt","Белгия":"be","Афганистан":"af","Албания":"al","Алжир":"dz","Андора":"ad","Ангола":"ao","Антигуа и Барбуда":"ag","Аржентина":"ar","Армения":"am","Австралия":"au","Австрия":"at","Азербайджан":"az","Бахами":"bs","Бахрейн":"bh","Бангладеш":"bd","Барбадос":"bb","Беларус":"by","Белиз":"bz","Бенин":"bj","Бутан":"bt","Боливия":"bo","Босна и Херцеговина":"ba","Ботсвана":"bw","Бразилия":"br","Бруней":"bn","Буркина Фасо":"bf","Бурунди":"bi","Камбоджа":"kh","Камерун":"cm","Канада":"ca","Централноафриканска република":"cf","Чад":"td","Чили":"cl","Китай":"cn","Колумбия":"co","Коморски острови":"km","Коста Рика":"cr","Хърватия":"hr","Куба":"cu","Кипър":"cy","Чехия":"cz","Демократична република Конго":"cd","Дания":"dk","Джибути":"dj","Доминика":"dm","Доминиканска република":"do","Еквадор":"ec","Египет":"eg","Салвадор":"sv","Екваториална Гвинея":"gq","Еритрея":"er","Естония":"ee","Есватини":"sz","Етиопия":"et","Фиджи":"fj","Финландия":"fi","Франция":"fr","Габон":"ga","Гамбия":"gm","Грузия":"ge","Гана":"gh","Гърция":"gr","Гренада":"gd","Гватемала":"gt","Гвинея":"gn","Гвинея-Бисау":"gw","Гвиана":"gy","Хаити":"ht","Хондурас":"hn","Унгария":"hu","Исландия":"is","Индия":"in","Индонезия":"id","Иран":"ir","Ирак":"iq","Ирландия":"ie","Израел":"il","Италия":"it","Кот д'Ивоар":"ci","Ямайка":"jm","Япония":"jp","Йордан":"jo","Казахстан":"kz","Кения":"ke","Кирибати":"ki","Кувейт":"kw","Киргизстан":"kg","Лаос":"la","Латвия":"lv","Ливан":"lb","Лесото":"ls","Либерия":"lr","Либия":"ly","Лихтенщайн":"li","Литва":"lt","Люксембург":"lu","Мадагаскар":"mg","Малави":"mw","Малайзия":"my","Малдиви":"mv","Мали":"ml","Малта":"mt","Маршалови острови":"mh","Мавритания":"mr","Мавриций":"mu","Мексико":"mx","Микронезия":"fm","Молдова":"md","Монако":"mc","Монголия":"mn","Черна гора":"me","Мароко":"ma","Мозамбик":"mz","Намибия":"na","Науру":"nr","Непал":"np","Нидерландия":"nl","Нова Зеландия":"nz","Никарагуа":"ni","Нигер":"ne","Нигерия":"ng","Северна Корея":"kp","Северна Македония":"mk","Норвегия":"no","Оман":"om","Пакистан":"pk","Палау":"pw","Палестина":"ps","Панама":"pa","Папуа Нова Гвинея":"pg","Парагвай":"py","Перу":"pe","Филипини":"ph","Полша":"pl","Катар":"qa","Република Конго":"cg","Русия":"ru","Руанда":"rw","Самоа":"ws","Сан Марино":"sm","Сао Томе и Принсипи":"st","Саудитска Арабия":"sa","Сенегал":"sn","Сърбия":"rs","Сейшели":"sc","Сиера Леоне":"sl","Сингапур":"sg","Словакия":"sk","Словения":"si","Соломонови острови":"sb","Сомалия":"so","Южна Африка":"za","Южна Корея":"kr","Южен Судан":"ss","Шри Ланка":"lk","Судан":"sd","Суринам":"sr","Швеция":"se","Швейцария":"ch","Сирия":"sy","Таджикистан":"tj","Танзания":"tz","Тайланд":"th","Тимор-Лесте":"tl","Того":"tg","Тонга":"to","Тринидад и Тобаго":"tt","Тунис":"tn","Турция":"tr","Туркменистан":"tm","Тувалу":"tv","Уганда":"ug","Украйна":"ua","Обединени арабски емирства":"ae","Обединено Кралство":"gb","Съединени щати":"us","Уругвай":"uy","Узбекистан":"uz","Вануату":"vu","Ватикана":"va","Венецуела":"ve","Виетнам":"vn","Йемен":"ye","Замбия":"zm","Зимбабве":"zw","United Kingdom":"gb","United States":"us","United Arab Emirates":"ae","Обединеното кралство":"gb","ОАЕ":"ae","Aruba":"aw","Аруба":"aw","Curaçao":"cw","Curacao":"cw","Кюрасао":"cw"};
    Object.entries(localizedCountries).forEach(([name, code]) => map.set(normalize(name), code));
    Object.entries(ALIASES).forEach(([name, code]) => map.set(normalize(name), code));
    return map;
  })();
  const flagUrl = country => {
    const key = normalize(country);
    const code = /^[a-z]{2}$/i.test(key) ? key : (COUNTRY_CODES.get(key) || '');
    return code ? `https\://flagcdn.com/${code}.svg` : '';
  };
  const isMetal = value => /gold|silver|злат|среб|silber/i.test(String(value || ''));
  const metalName = value => /silver|среб|silber/i.test(String(value || '')) ? 'Silver' : 'Gold';
  const groupCountries = variants => {
    const map = new Map();
    variants.forEach(variant => {
      const options = (variant.options || [variant.option1, variant.option2, variant.option3]).filter(Boolean);
      const metalOption = options.find(isMetal);
      const country = options.find(option => !isMetal(option));
      if (!country) return;
      if (!map.has(country)) map.set(country, { country, Gold: null, Silver: null });
      map.get(country)[metalName(metalOption)] = variant;
    });
    return [...map.values()].sort((a, b) => a.country.localeCompare(b.country));
  };
  const styleToken = style => style.replace('/', '');
  const styleDescription = style => {
    const [metal, leather] = style.split('/');
    return isBg ? `${leather==='Brown' ? 'Кафява' : 'Черна'} кожа · ${mvText(metal)} елементи` : `${leather} leather · ${metal} hardware`;
  };
  const initBuilder = root => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const holderCard = root.querySelector('[data-holder-card]');
    const holders = [...root.querySelectorAll('[data-holder]')];
    const holderMetals = [...root.querySelectorAll('[data-holder-metal]')];
    const keychainSwatches = [...root.querySelectorAll('[data-keychain-style]')];
    const keychainSwatchesWrap = root.querySelector('[data-keychain-swatches]');
    const holderMetalsWrap = root.querySelector('[data-holder-metals]');
    const finishName = root.querySelector('[data-finish-name]');
    const flagMetals = [...root.querySelectorAll('[data-flag-metal]')];
    const flagsCard = root.querySelector('[data-flags-card]');
    const search = root.querySelector('[data-search]');
    const count = root.querySelector('[data-count]');
    const progress = root.querySelector('[data-progress]');
    const selectedWrap = root.querySelector('[data-selected-wrap]');
    const selectedSummary = root.querySelector('[data-selected-summary]');
    const selectedChips = root.querySelector('[data-selected-chips]');
    const flagsGrid = root.querySelector('[data-flags-grid]');
    const flagsScroll = root.querySelector('[data-flags-scroll]');
    const addButton = root.querySelector('[data-add]');
    const lockSummary = root.querySelector('[data-lock-summary]');
    const variantsNode = root.querySelector('[data-flag-variants]');
    let activeHolder = 0;
    let flagMetal = 'Gold';
    let selected = new Map();
    let added = false;
    const holderSelections = holders.map(holder => (
      holder.dataset.isKeychain === 'true' ? 'Gold/Brown' : 'Gold'
    ));
    let variants = [];
    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (_) {}
    let countries = groupCountries(variants);
    const FLAGS_GIFT_RULE='mubh24p94s3doo08eb5';
    const selectedQuantity = () => [...selected.values()].reduce((sum,qty)=>sum+qty,0);
    let cartPaidFlags=0,cartOfferGifts=0,cartLoaded=false,cartRevision=0;
    const cartVariantQuantities=new Map();
    const editableCartLines=new Map();
    let cartPaidUnits=[],cartGiftUnits=[];
    const readCartOffer = cart => {
      cartPaidFlags=0;cartOfferGifts=0;cartVariantQuantities.clear();editableCartLines.clear();cartPaidUnits=[];cartGiftUnits=[];
      const ids=new Set(variants.map(v=>Number(v.id)));
      for(const item of cart.items || []){
        if(!ids.has(Number(item.variant_id)))continue;
        cartVariantQuantities.set(Number(item.variant_id),(cartVariantQuantities.get(Number(item.variant_id))||0)+item.quantity);
        const props=item.properties || {};
        if(props._aiod_rule_id==='mua82fpsr8zim0e3f8i' || props['_MONTEVIERA keychain gift'])continue;
        if(props._aiod_rule_id===FLAGS_GIFT_RULE && props._aiod_free_gift==='true'){cartOfferGifts+=item.quantity;for(let n=0;n<item.quantity;n++)cartGiftUnits.push(Number(item.variant_id));continue;}
        let free=0;
        for(const allocation of item.line_level_discount_allocations || []){
          if(/buy\s*5.*get\s*2/i.test(allocation.discount_application?.title || '') && item.original_price>0)
            free+=Math.round(allocation.amount/item.original_price);
        }
        free=Math.min(item.quantity,free);
        if(props._aiod_free_gift==='true' && !free)continue;
        // Only fully paid, non-promotional lines can be edited by the builder.
        if(!free && props._aiod_free_gift!=='true' && item.key){
          const lines=editableCartLines.get(Number(item.variant_id))||[];
          lines.push({key:item.key,quantity:item.quantity});
          editableCartLines.set(Number(item.variant_id),lines);
        }
        cartOfferGifts+=free;cartPaidFlags+=item.quantity-free;
        for(let n=0;n<item.quantity-free;n++)cartPaidUnits.push(Number(item.variant_id));
        for(let n=0;n<free;n++)cartGiftUnits.push(Number(item.variant_id));
      }
      cartLoaded=true;
    };
    const offerPreview = quantity => {
      let paid=cartPaidFlags,free=cartOfferGifts,selectedFree=0;
      for(let i=0;i<quantity;i++){
        if(free<Math.floor(paid/5)*2){free++;selectedFree++;}else paid++;
      }
      const earned=Math.floor(paid/5)*2;
      return {paid,free,remaining:5-paid%5,owed:Math.max(0,earned-free),selectedFree,complete:earned>0 && free>=earned};
    };
    const flagPlan = () => {
      let paid=cartPaidFlags,free=cartOfferGifts;
      const paidItems=[],giftItems=[],freeById=new Map();
      for(const [id,qty] of selected){
        if(!variants.find(v=>Number(v.id)===id && v.available))continue;
        let paidQty=0,freeQty=0;
        for(let unit=0;unit<qty;unit++){
          if(free<Math.floor(paid/5)*2){free++;freeQty++;}else{paid++;paidQty++;}
        }
        if(paidQty)paidItems.push({id,quantity:paidQty});
        if(freeQty){giftItems.push({id,quantity:freeQty,properties:{_aiod_free_gift:'true',_aiod_rule_id:FLAGS_GIFT_RULE}});freeById.set(id,freeQty);}
      }
      return {paidItems,giftItems,freeById};
    };
    let holderVariants=[];
    try{holderVariants=JSON.parse(root.querySelector('[data-holder-variants]')?.textContent || '[]');}catch(_){}
    const holderAvailable = () => {
      const v=holderVariants.find(v=>Number(v.id)===activeHolderVariantId());
      return v ? v.available : false;
    };
    const setPressed = (buttons, active, dataKey) => {
      buttons.forEach(button => {
        button.setAttribute(
          'aria-pressed',
          button.dataset[dataKey] === active ? 'true' : 'false'
        );
      });
    };
    const activeHolderElement = () => holders[activeHolder];
    const holderData = (holder, selection, type) => {
      if (!holder) return '';
      if (holder.dataset.isKeychain === 'true') {
        const token = styleToken(selection);
        return holder.dataset[`style${token}${type}`] || '';
      }
      return holder.dataset[`${selection.toLowerCase()}${type}`] || '';
    };
    const activeHolderVariantId = () => {
      const holder = activeHolderElement();
      const selection = holderSelections[activeHolder];
      const id = holderData(holder, selection, 'Variant');
      return id ? Number(id) : null;
    };
    const updateHolderVisual = index => {
      const holder = holders[index];
      if (!holder) return;
      const selection = holderSelections[index];
      const image = holder.querySelector('[data-holder-image]');
      const price = holder.querySelector('[data-holder-price]');
      const imageUrl = holderData(holder, selection, 'Image');
      const priceText = holderData(holder, selection, 'Price');
      if (image && imageUrl) {
        image.removeAttribute('srcset');
        image.src = imageUrl;
      }
      if (price && priceText) {
        price.textContent = priceText;
      }
      if(index===activeHolder && holderCard.dataset.locked!=='true'){
        const action=root.querySelector('[data-continue]');
        if(action){action.disabled=!holderAvailable();action.textContent=holderAvailable() ? mvText("Choose this holder →") : mvText("COMING SOON");}
      }
    };
    const updateAllHolderVisuals = () => {
      holders.forEach((_, index) => updateHolderVisual(index));
    };
    const updateHolderPositions = () => {
      holders.forEach((holder, index) => {
        const diff = (index - activeHolder + holders.length) % holders.length;
        holder.dataset.pos = diff === 0 ? 'center' : diff === 1 ? 'right' : 'left';
      });
    };
    const updateFinishControls = () => {
      const holder = activeHolderElement();
      if (!holder) return;
      const selection = holderSelections[activeHolder];
      const isKeychain = holder.dataset.isKeychain === 'true';
      if (keychainSwatchesWrap) keychainSwatchesWrap.hidden = !isKeychain;
      if (holderMetalsWrap) holderMetalsWrap.hidden = isKeychain;
      if (isKeychain) {
        setPressed(keychainSwatches, selection, 'keychainStyle');
        if (finishName) finishName.textContent = styleDescription(selection);
      } else {
        setPressed(holderMetals, selection, 'holderMetal');
        if (finishName) finishName.textContent = isBg ? `${mvText(selection)} покритие` : `${selection} finish`;
      }
    };
    const setActiveHolder = index => {
      activeHolder = index;
      added = false;
      updateHolderPositions();
      updateFinishControls();
      updateAddButton();
    };
    holders.forEach((holder, index) => {
      holder.addEventListener('click', () => {
        if (index !== activeHolder) setActiveHolder(index);
        openQuickShop();
      });
    });
    root.querySelector('[data-holder-prev]')?.addEventListener('click', () => {
      setActiveHolder((activeHolder - 1 + holders.length) % holders.length);
    });
    root.querySelector('[data-holder-next]')?.addEventListener('click', () => {
      setActiveHolder((activeHolder + 1) % holders.length);
    });
    keychainSwatches.forEach(button => {
      button.addEventListener('click', () => {
        if (activeHolderElement()?.dataset.isKeychain !== 'true') return;
        holderSelections[activeHolder] = button.dataset.keychainStyle;
        added = false;
        updateHolderVisual(activeHolder);
        updateFinishControls();
        updateAddButton();
      });
    });
    holderMetals.forEach(button => {
      button.addEventListener('click', () => {
        const holder = activeHolderElement();
        if (!holder || holder.dataset.isKeychain === 'true') return;
        holderSelections[activeHolder] = button.dataset.holderMetal;
        added = false;
        updateHolderVisual(activeHolder);
        updateFinishControls();
        updateAddButton();
      });
    });
    const cartRoot = window.Shopify?.routes?.root || '/';
    const cartRequest = async (endpoint, body) => {
      const response = await fetch(cartRoot + endpoint, {
        method: body ? 'POST' : 'GET',
        headers: {'Content-Type':'application/json', Accept:'application/json'},
        ...(body ? {body:JSON.stringify(body)} : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || mvText("Could not update cart. Please try again."));
      return data;
    };
    const syncCartOffer = async () => {
      const revision=++cartRevision;
      try{const cart=await cartRequest('cart.js');if(revision!==cartRevision)return;readCartOffer(cart);renderFlags();}
      catch(_){if(!cartLoaded && progress)progress.textContent=mvText("Cart progress will update when your cart is available.");}
    };
    let builderGroup = null;
    let giftAdded = false;
    let busy = false;
    let dialogMode = 'product';
    const continueButton = root.querySelector('[data-continue]');
    const status = document.createElement('p');
    status.className = 'mvb-status'; status.setAttribute('role','status');
    continueButton.before(status);
    const quick = document.createElement('dialog');
    quick.className = 'mvb-quick';
    quick.setAttribute('aria-label',mvText("Choose your holder and free flag"));
    quick.innerHTML = `<div class="mvb-quick-body"><button type="button" class="mvb-quick-close" aria-label="Close">×</button>
      <div data-quick-content></div><p class="mvb-quick-error" role="alert" hidden></p></div>`;
    root.append(quick);
    const content = quick.querySelector('[data-quick-content]');
    const error = quick.querySelector('.mvb-quick-error');
    const text = (tag, value, cls) => { const e=document.createElement(tag); e.textContent=mvText(value); if(cls)e.className=cls; return e; };
    const closeQuick = () => {if (!busy) quick.close();};
    quick.querySelector('.mvb-quick-close').addEventListener('click', closeQuick);
    quick.addEventListener('cancel', e => {if(busy)e.preventDefault();});
    quick.addEventListener('click', e => {if(e.target===quick)closeQuick();});
    const refreshCartCount = async () => {
      try {
        const cart = await cartRequest('cart.js');
        readCartOffer(cart);renderFlags();
        const {CartLinesUpdateEvent} = await import('@shopify/events');
        document.dispatchEvent(new CartLinesUpdateEvent({action:'update', context:'product', lines:[],
          promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'monteviera-builder',didError:false}})}));
      } catch (_) {}
    };
    const settleHolder = () => {
      holderCard.dataset.locked = 'true';
      const h=activeHolderElement(), selection=holderSelections[activeHolder];
      lockSummary.textContent = h.dataset.name + ' · ' + (h.dataset.isKeychain==='true' ? styleDescription(selection) : selection);
      continueButton.disabled=false;
      continueButton.textContent=giftAdded ? mvText("View cart →") : mvText("Choose your free flag →");
      status.textContent=giftAdded ? mvText("✓ Holder and free flag added to your cart") : mvText("✓ Holder added · Choose your included flag");
    };
    const showGift = async () => {
      await completeFlagData;
      dialogMode='gift';quick.dataset.mode='gift';content.replaceChildren();error.hidden=true;
      content.append(text('div',mvText("COMPLIMENTARY WITH YOUR HOLDER"),'mvb-quick-eyebrow'),text('h2',mvText("Choose your FREE flag")));
      const metals=document.createElement('div');metals.className='mvb-gift-metals';content.append(metals);
      let metal='Gold',chosen=null;
      const trigger=text('button',mvText("Choose your country ▾"),'mvb-country-trigger');trigger.type='button';trigger.setAttribute('aria-expanded','false');content.append(trigger);
      const panel=document.createElement('div');panel.className='mvb-country-panel';panel.hidden=true;content.append(panel);
      const find=document.createElement('input');find.type='search';find.placeholder=mvText("Search country…");find.setAttribute('aria-label',mvText("Search country"));panel.append(find);
      const list=document.createElement('div');list.className='mvb-country-list';panel.append(list);
      const add=text('button',mvText("ADD MY FREE FLAG"),'mvb-quick-primary');add.type='button';add.disabled=true;content.append(add);
      const setChosen = v => {
        chosen=v;trigger.replaceChildren();
        if(v){const img=document.createElement('img');img.src=flagUrl(v.option2);img.alt='';trigger.append(img,text('span',v.option2),text('span','▾'));}
        else trigger.textContent=mvText("Choose your country ▾");
        add.disabled=!v;
      };
      const render = () => {
        list.replaceChildren();
        const matches=variants.filter(v=>metalName(v.option1)===metal && v.option2.toLowerCase().includes(find.value.trim().toLowerCase())).sort((a,b)=>Number(b.available)-Number(a.available)||a.option2.localeCompare(b.option2));
        for(const v of matches){
          const row=document.createElement('button');row.type='button';row.className='mvb-country-option';row.disabled=!v.available;
          const img=document.createElement('img');img.src=flagUrl(v.option2);img.alt='';img.loading='lazy';
          row.append(img,text('span',v.option2));if(!v.available)row.append(text('small',mvText("COMING SOON")));
          row.addEventListener('click',()=>{setChosen(v);panel.hidden=true;trigger.setAttribute('aria-expanded','false');});list.append(row);
        }
        if(!matches.length)list.append(text('p',mvText("No countries found.")));
      };
      for(const value of ['Gold','Silver']){
        const button=text('button',value);button.type='button';button.setAttribute('aria-pressed',String(value===metal));
        button.addEventListener('click',()=>{metal=value;metals.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));setChosen(null);render();});metals.append(button);
      }
      trigger.addEventListener('click',()=>{panel.hidden=!panel.hidden;trigger.setAttribute('aria-expanded',String(!panel.hidden));if(!panel.hidden)find.focus();});
      find.addEventListener('input',render);render();
      add.addEventListener('click',async()=>{
        if(busy || !chosen?.available)return;busy=true;add.disabled=true;add.textContent=mvText("ADDING…");error.hidden=true;
        try{
          await cartRequest('cart/add.js',{items:[{id:Number(chosen.id),quantity:1,properties:{_aiod_free_gift:'true',_aiod_rule_id:'mua82fpsr8zim0e3f8i',_monteviera_builder:builderGroup}}]});
          giftAdded=true;busy=false;quick.close();settleHolder();await refreshCartCount();
          flagsCard.scrollIntoView({behavior:'smooth',block:'center'});search?.focus({preventScroll:true});
        }catch(e){busy=false;error.textContent=e.message;error.hidden=false;add.disabled=false;add.textContent=mvText("ADD MY FREE FLAG");}
      });
      if(!quick.open)quick.showModal();
    };
    const ensureHolderData = async () => {
      const h=activeHolderElement(), selection=holderSelections[activeHolder];
      if(activeHolderVariantId())return;
      const name=h.dataset.name.toLowerCase();
      const configured=root.dataset[name+'Url'];
      const candidates=configured ? [configured.replace(/\?.*$/, '')+'.js']
        : (name==='bracelet' ? ['products/bracelet.js','products/bracelets.js'] : ['products/'+name+'.js']);
      for(const endpoint of candidates){
        try{
          const url=endpoint.startsWith('/') ? endpoint : cartRoot+endpoint;
          const response=await fetch(url,{headers:{Accept:'application/json'}});
          if(!response.ok)continue;
          const product=await response.json();if(!Array.isArray(product.variants))continue;
          const parts=selection.toLowerCase().split('/');
          const v=product.variants.find(v=>parts.every(part=>String(v.title).toLowerCase().includes(part)))
            || (product.variants.length===1 ? product.variants[0] : null);
          if(!v)continue;
          const prefix=h.dataset.isKeychain==='true' ? 'style'+styleToken(selection) : selection.toLowerCase();
          h.dataset[prefix+'Variant']=String(v.id);
          holderVariants.push({id:v.id,available:v.available});
          h.dataset[prefix+'Price']=new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(v.price/100);
          root.dataset[name+'Url']=cartRoot+'products/'+product.handle;
          updateHolderVisual(activeHolder);return;
        }catch(_){}
      }
    };
    const chooseHolder = async () => {
      if(busy)return;
      busy=true;continueButton.disabled=true;
      await ensureHolderData();
      const id=activeHolderVariantId();
      if(!id){
        const message='This holder is not connected to a product yet. Please open View full details, or choose another holder.';
        status.textContent=message;error.textContent=message;error.hidden=false;busy=false;continueButton.disabled=false;return;
      }
      if(!holderAvailable()){busy=false;continueButton.disabled=true;continueButton.textContent=mvText("COMING SOON");error.textContent=mvText("This holder is coming soon.");error.hidden=false;return;}
      busy=true;error.hidden=true;continueButton.disabled=true;
      const nextGroup='mvb-'+Date.now()+'-'+Math.random().toString(36).slice(2);
      const oldGroup=builderGroup;
      try{
        // Record only this builder's lines; never remove unrelated purchases.
        const before=oldGroup ? await cartRequest('cart.js') : null;
        await cartRequest('cart/add.js',{items:[{id,quantity:1,properties:{_monteviera_builder:nextGroup}}]});
        if(before){
          const updates={};for(const item of before.items){if(item.properties?._monteviera_builder===oldGroup)updates[item.key]=0;}
          if(Object.keys(updates).length){
            try{await cartRequest('cart/update.js',{updates});}
            catch(e){
              const now=await cartRequest('cart.js');const rollback={};for(const item of now.items){if(item.properties?._monteviera_builder===nextGroup)rollback[item.key]=0;}
              if(Object.keys(rollback).length)await cartRequest('cart/update.js',{updates:rollback});
              throw e;
            }
          }
        }
        builderGroup=nextGroup;giftAdded=false;busy=false;settleHolder();showGift();await refreshCartCount();
      }catch(e){busy=false;continueButton.disabled=false;status.textContent=e.message;error.textContent=e.message;error.hidden=false;}
    };
    const openQuickShop = async () => {
      if(holderCard.dataset.locked==='true' || busy)return;
      await ensureHolderData();
      dialogMode='product';quick.dataset.mode='product';content.replaceChildren();error.hidden=true;
      const h=activeHolderElement(), selection=holderSelections[activeHolder];
      const layout=document.createElement('div');layout.className='mvb-quick-product';
      const image=document.createElement('img');image.src=holderData(h,selection,'Image') || h.querySelector('img').src;image.alt=h.dataset.name;
      const info=document.createElement('div');info.append(text('div',mvText("+1 FREE FLAG"),'mvb-quick-eyebrow'),text('h2',mvText(h.dataset.name)),text('p',holderData(h,selection,'Price'),'mvb-quick-price'));
      const opts=document.createElement('div');opts.className='mvb-quick-controls';
      const source=h.dataset.isKeychain==='true' ? keychainSwatches : holderMetals;
      for(const original of source){const b=original.cloneNode(true);b.removeAttribute('data-keychain-style');b.removeAttribute('data-holder-metal');b.addEventListener('click',()=>{original.click();openQuickShop();});opts.append(b);}
      info.append(opts,text('p',h.dataset.isKeychain==='true' ? styleDescription(selection) : selection));
      const choose=text('button',holderAvailable() ? mvText("Choose this holder →") : mvText("COMING SOON"),'mvb-quick-primary');choose.type='button';choose.disabled=!holderAvailable();choose.addEventListener('click',chooseHolder);info.append(choose);
      const link=text('a',mvText("View full details"),'mvb-quick-details');link.href=root.dataset[h.dataset.name.toLowerCase()+'Url'] || '/collections/holders';info.append(link);
      layout.append(image,info);content.append(layout);if(!quick.open)quick.showModal();
    };
    continueButton?.addEventListener('click',()=>{
      if(holderCard.dataset.locked==='true'){
        if(giftAdded)window.location.assign(cartRoot+'cart');else showGift();
      }else chooseHolder();
    });
    root.querySelector('[data-unlock]')?.addEventListener('click',()=>{
      if(busy)return;holderCard.dataset.locked='false';updateHolderVisual(activeHolder);
      status.textContent=mvText("Choose a replacement. Your current holder stays in the cart until you confirm.");
    });
    const variantFor = entry => entry[flagMetal];
    const currentMaster = () => (
      flagMetal === 'Silver'
        ? flagsCard.dataset.silverMaster
        : flagsCard.dataset.goldMaster
    );
    const pruneSelection = () => {
      for(const [id] of selected){if(!variants.find(v=>Number(v.id)===id && v.available))selected.delete(id);}
    };
    const updateProgress = () => {
      const preview=offerPreview(selectedQuantity());
      const complete=Math.min(Math.floor(preview.paid/5),Math.floor(preview.free/2));
      const paidNow=Math.min(5,Math.max(0,preview.paid-complete*5));
      const freeNow=Math.min(2,Math.max(0,preview.free-complete*2));
      if(count)count.textContent=cartLoaded ? `${paidNow}/5 ${isBg?'платени':'paid'} · ${freeNow}/2 ${isBg?'подаръка':'FREE'}` : '…';
      const completed=root.querySelector('[data-completed]');
      if(completed){
        completed.hidden=!complete;completed.replaceChildren();
        const plan=flagPlan(),allPaid=[...cartPaidUnits],allGifts=[...cartGiftUnits];
        for(const item of plan.paidItems)for(let n=0;n<item.quantity;n++)allPaid.push(item.id);
        for(const item of plan.giftItems)for(let n=0;n<item.quantity;n++)allGifts.push(item.id);
        for(let set=0;set<complete;set++){
          const row=document.createElement('div');row.className='mvb-completed-set';
          const label=document.createElement('span');label.textContent=isBg?`✓ Комплект ${set+1}`:`✓ Set ${set+1}`;row.append(label);
          const strip=document.createElement('div');strip.className='mvb-completed-flags';
          const ids=[...allPaid.slice(set*5,set*5+5),...allGifts.slice(set*2,set*2+2)];
          ids.forEach((id,i)=>{const v=variants.find(v=>Number(v.id)===id);if(!v)return;const flag=document.createElement('span');flag.className='mvb-completed-flag'+(i>=5?' is-gift':'');const image=document.createElement('img');image.src=flagUrl(v.option2);image.alt=mvText(v.option2);flag.title=mvText(v.option2)+(i>=5?(isBg?' · Подарък':' · FREE'):'');flag.append(image);strip.append(flag);});
          row.append(strip);completed.append(row);
        }
      }
      const slots=root.querySelector('[data-offer-slots]');
      if(slots){
        const paid=[...cartPaidUnits],gifts=[...cartGiftUnits];
        const plan=flagPlan();
        for(const item of plan.paidItems)for(let n=0;n<item.quantity;n++)paid.push(item.id);
        for(const item of plan.giftItems)for(let n=0;n<item.quantity;n++)gifts.push(item.id);
        slots.replaceChildren();
        for(let i=0;i<7;i++){
          const gift=i>=5;const id=gift?gifts[complete*2+i-5]:paid[complete*5+i];
          const slot=document.createElement('span');slot.className='mvb-offer-slot'+(gift?' mvb-offer-slot--gift':'')+(id?' is-filled':'');
          const v=variants.find(v=>Number(v.id)===id);
          if(v){const image=document.createElement('img');image.src=flagUrl(v.option2);image.alt=mvText(v.option2);slot.title=mvText(v.option2)+(gift?(isBg?' · Подарък':' · FREE'):'');slot.append(image);}
          else if(gift){slot.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 9h18v4H3zM5 13v8h14v-8M12 9v12"/><path d="M12 9C2 9 6 0 12 9c6-9 10 0 0 0Z"/></svg>';slot.setAttribute('aria-label',isBg?'Място за подарък':'Gift slot');}
          else slot.setAttribute('aria-label',isBg?'Място за платен флаг':'Paid flag slot');
          slots.append(slot);
        }
      }
      if(progress){progress.textContent=!cartLoaded?mvText('Loading your cart progress…'):preview.owed?(isBg?`Избери още ${preview.owed} подаръчни флага`:`Choose ${preview.owed} more FREE flags`):'';progress.hidden=!progress.textContent;}
      const formatter=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'});
      root.querySelectorAll('[data-metal-price]').forEach(el=>{const v=variants.find(v=>metalName(v.option1)===el.dataset.metalPrice);el.textContent=v?formatter.format(v.price/100):'';});
    };
    const renderSelected = () => {
      if(!selectedWrap || !selectedChips)return;
      selectedWrap.hidden=selected.size===0;selectedChips.replaceChildren();
      if(selectedSummary)selectedSummary.textContent=`${selectedQuantity()} ${isBg ? 'избрани' : 'selected'}`;
      const {freeById}=flagPlan();
      for(const [id,qty] of selected){
        const v=variants.find(v=>Number(v.id)===id);if(!v)continue;
        const chip=document.createElement('span');chip.className='mvb-selected-chip';
        const image=document.createElement('img');image.className='mvb-selected-chip__flag';image.src=flagUrl(v.option2);image.alt='';
        const label=document.createElement('span');label.textContent=`${v.option2} · ${mvText(v.option1)} ×${qty}`;
        const remove=document.createElement('button');remove.type='button';remove.className='mvb-selected-chip__remove';remove.textContent='×';remove.setAttribute('aria-label',isBg ? `Премахни ${v.option2}` : `Remove ${v.option2}`);
        remove.addEventListener('click',()=>{if(flagsBusy)return;selected.delete(id);renderFlags();});chip.append(image,label);
        const freeQty=cartLoaded ? freeById.get(id)||0 : 0;
        if(freeQty){const badge=document.createElement('span');badge.className='mvb-selected-chip__free';badge.textContent=freeQty===qty ? (qty===1 ? mvText("FREE") : `${qty} ${mvText('FREE')}`) : `${freeQty} ${mvText('FREE')}`;chip.append(badge);}
        chip.append(remove);selectedChips.append(chip);
      }
    };
    function updateAddButton() {
      const total = selectedQuantity();
      if (!addButton) return;
      addButton.disabled = total === 0 || flagsBusy;
      addButton.textContent = mvText("ADD FLAGS TO CART →");
      updateProgress();
      renderSelected();
    }
    const setMobileHeight = () => {
      if (!flagsScroll || !flagsGrid) return;
      if (window.innerWidth > 749) {
        flagsScroll.style.height = '';
        return;
      }
      const cards = [...flagsGrid.querySelectorAll('.mvb-flag')];
      if (!cards.length) return;
      const gridStyle = getComputedStyle(flagsGrid);
      const columns = gridStyle.gridTemplateColumns
        .split(' ')
        .filter(Boolean)
        .length || 3;
      const firstRow = cards.slice(0, columns);
      const secondRow = cards.slice(columns, columns * 2);
      const firstRowHeight = Math.max(...firstRow.map(card => card.offsetHeight));
      const secondRowHeight = secondRow.length
        ? Math.max(...secondRow.map(card => card.offsetHeight))
        : firstRowHeight;
      const gap = parseFloat(gridStyle.rowGap) || 7;
      const twoRows=firstRowHeight + secondRowHeight + gap + 2;
      flagsScroll.style.height = `${Math.min(twoRows,Math.max(130,Math.min(210,window.innerHeight*.27)))}px`;
    };
    const changeCartFlag = async (id, delta) => {
      if(flagsBusy)return;
      const lines=editableCartLines.get(id)||[];
      const line=delta<0 ? lines[lines.length-1] : lines[0];
      if(!line)return;
      flagsBusy=true;
      try{
        await cartRequest('cart/change.js',{id:line.key,quantity:Math.max(0,line.quantity+delta)});
        await refreshCartCount();
      }catch(error){
        if(flagsStatus)flagsStatus.textContent=error.message || mvText('Could not update cart. Please try again.');
        await syncCartOffer();
      }finally{flagsBusy=false;renderFlags();}
    };
    const renderFlags = () => {
      if (!flagsGrid) return;
      const query = normalize(search?.value);
      const master = currentMaster();
      flagsGrid.innerHTML = '';
      [...countries].sort((a, b) => {
        const aAvailable = variantFor(a)?.available === true;
        const bAvailable = variantFor(b)?.available === true;
        return Number(bAvailable) - Number(aAvailable) || a.country.localeCompare(b.country);
      }).forEach(entry => {
        const variant = variantFor(entry);
        if (!variant) return;
        if (query && !normalize(entry.country).includes(query)) return;
        const card = document.createElement('div');
        card.setAttribute('role','button');card.tabIndex=variant.available ? 0 : -1;
        card.className = 'mvb-flag';
        card.disabled = variant.available === false;
        if (card.disabled) card.classList.add('mvb-sold-out');
        card.setAttribute(
          'aria-pressed',
          (selected.has(Number(variant.id)) || cartVariantQuantities.get(Number(variant.id))>0) ? 'true' : 'false'
        );
        const check = document.createElement('span');
        check.className = 'mvb-check';
        check.textContent = '✓';
        const visual = document.createElement('div');
        visual.className = 'mvb-charm';
        const windowEl = document.createElement('div');
        windowEl.className = 'mvb-flag-window';
        const url = flagUrl(entry.country);
        if (url) {
          const flag = document.createElement('img');
          flag.className = 'mvb-flag-image';
          flag.src = url;
          flag.alt = `${entry.country} flag`;
          flag.loading = 'lazy';
          flag.decoding = 'async';
          windowEl.appendChild(flag);
        } else {
          const fallback = document.createElement('div');
          fallback.className = 'mvb-fallback';
          fallback.textContent = entry.country.slice(0, 2).toUpperCase();
          windowEl.appendChild(fallback);
        }
        visual.appendChild(windowEl);
        if (master) {
          const masterImage = document.createElement('img');
          masterImage.className = 'mvb-charm-master';
          masterImage.src = master;
          masterImage.alt = '';
          masterImage.loading = 'lazy';
          masterImage.decoding = 'async';
          visual.appendChild(masterImage);
        }
        const name = document.createElement('span');
        name.className = 'mvb-flag-name';
        const displayName = mvText(entry.country);
        name.textContent = displayName;
        name.title = displayName;
        if (displayName.length > 18) name.classList.add('mvb-flag-name--long');
        if (displayName.length > 28) name.classList.add('mvb-flag-name--extra-long');
        if (variant.available === false) {
          const badge = document.createElement('span');
          badge.className = 'mvb-sold-badge';
          badge.textContent = mvText("COMING SOON");
          visual.appendChild(badge);
        } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 3) {
          const badge = document.createElement('span');
          badge.className = 'mvb-low-stock';
          badge.textContent = isBg
            ? `Последни ${variant.inventory_quantity}`
            : `${variant.inventory_quantity} left`;
          visual.appendChild(badge);
        }
        card.append(check, visual, name);
        const id=Number(variant.id),qty=selected.get(id)||0;
        const inCart=cartVariantQuantities.get(id)||0;
        if(inCart){const cartBadge=document.createElement('span');cartBadge.className='mvb-in-cart';cartBadge.textContent=isBg?`${inCart} в количката`:`${inCart} in cart`;card.append(cartBadge);}
        const editableLines=editableCartLines.get(id)||[];
        if(qty || editableLines.length){
          const stepper=document.createElement('div');stepper.className='mvb-quantity';
          const minus=document.createElement('button');minus.type='button';minus.textContent='−';minus.setAttribute('aria-label',isBg ? `Премахни един ${entry.country}` : `Remove one ${entry.country}`);
          const amount=document.createElement('span');amount.textContent=String(inCart+qty);amount.setAttribute('aria-live','polite');
          const plus=document.createElement('button');plus.type='button';plus.textContent='+';plus.setAttribute('aria-label',isBg ? `Добави един ${entry.country}` : `Add one ${entry.country}`);
          const max=variant.inventory_policy==='deny' && variant.inventory_management ? Math.max(0,variant.inventory_quantity-(cartVariantQuantities.get(id)||0)) : Infinity;
          plus.disabled=qty>=max || variant.available===false;
          minus.addEventListener('click',e=>{e.stopPropagation();if(flagsBusy)return;if(qty){if(qty>1)selected.set(id,qty-1);else selected.delete(id);renderFlags();}else changeCartFlag(id,-1);});
          plus.addEventListener('click',e=>{e.stopPropagation();if(flagsBusy || qty>=max)return;if(editableLines.length && !qty)changeCartFlag(id,1);else{selected.set(id,qty+1);added=false;renderFlags();}});
          stepper.append(minus,amount,plus);card.append(stepper);
        }
        const toggle=()=>{
          if(flagsBusy || variant.available===false)return;
          if(selected.has(id))selected.delete(id);else selected.set(id,1);
          added=false;renderFlags();
        };
        card.addEventListener('click',toggle);
        card.addEventListener('keydown',e=>{if(e.target===card && (e.key==='Enter'||e.key===' ')){e.preventDefault();toggle();}});
        flagsGrid.appendChild(card);
      });
      requestAnimationFrame(setMobileHeight);
      updateAddButton();
    };
    flagMetals.forEach(button => {
      button.addEventListener('click', () => {
        flagMetal = button.dataset.flagMetal;
        added = false;
        setPressed(flagMetals, flagMetal, 'flagMetal');
        pruneSelection();
        renderFlags();
      });
    });
    search?.addEventListener('input', () => {
      renderFlags();
      if (flagsScroll) {
        flagsScroll.scrollTop = 0;
      }
    });
    window.addEventListener('resize', setMobileHeight);
    const selectedFlagItems = () => [...selected].filter(([id])=>variants.find(v=>Number(v.id)===id && v.available)).map(([id,quantity])=>({id,quantity}));
    let flagsBusy=false;
    const checkoutButton=root.querySelector('[data-builder-checkout]');
    const flagsStatus=root.querySelector('[data-flags-status]');
    const addVerifiedFlagItems = async items => {
      const response=await cartRequest('cart/add.js',{items});
      const actual=response.items || (response.variant_id ? [response] : []);
      const expected=new Map();for(const item of items)expected.set(Number(item.id),(expected.get(Number(item.id))||0)+item.quantity);
      const received=new Map();for(const item of actual){const id=Number(item.variant_id || item.id);received.set(id,(received.get(id)||0)+item.quantity);}
      if(expected.size!==received.size || [...expected].some(([id,qty])=>received.get(id)!==qty))throw new Error(isBg?'Shopify върна различни флагове. Провери количката преди ново добавяне.':'Shopify returned different flags. Check your cart before adding again.');
      return response;
    };
    const addSelectedFlags = async () => {
      if(flagsBusy)return false;
      if(!selectedQuantity())return true;
      flagsBusy=true;addButton.disabled=true;checkoutButton.disabled=true;
      addButton.textContent=mvText("Adding…");flagsStatus.textContent='';
      const consume = items => {
        for(const item of items){const remaining=(selected.get(item.id)||0)-item.quantity;if(remaining>0)selected.set(item.id,remaining);else selected.delete(item.id);}
      };
      let paidAdded=false;
      try{
        const cart=await cartRequest('cart.js');readCartOffer(cart);
        const plan=flagPlan();
        if(plan.paidItems.length){
          await addVerifiedFlagItems(plan.paidItems);consume(plan.paidItems);paidAdded=true;
        }
        if(plan.giftItems.length){
          await addVerifiedFlagItems(plan.giftItems);consume(plan.giftItems);
        }
        added=false;renderFlags();
        await refreshCartCount();
        flagsStatus.textContent=mvText("✓ Your flags and eligible gifts have been added");
        return true;
      }catch(e){
        await refreshCartCount();renderFlags();
        flagsStatus.textContent=paidAdded ? `Paid flags added. Your gift selection is saved — ${e.message}` : e.message;
        return false;
      }finally{flagsBusy=false;checkoutButton.disabled=false;updateAddButton();}
    };
    addButton?.addEventListener('click',()=>addSelectedFlags());
    checkoutButton?.addEventListener('click',async()=>{
      if(flagsBusy || busy)return;
      if(await addSelectedFlags()){
        const cart=await cartRequest('cart.js');
        if(!cart.item_count){flagsStatus.textContent=mvText("Choose a holder or flags first.");return;}
        window.location.assign(cartRoot+'cart?sw-checkout=1');
      }
    });
    const completeFlagData = (async () => {
      const node=root.querySelector('[data-flag-options]');if(!node)return;
      let config;try{config=JSON.parse(node.textContent);}catch(_){return;}
      const results=await Promise.allSettled(config.metals.map(async option=>{
        const url=new URL(config.url,window.location.origin);
        url.searchParams.set('section_id','monteviera-flag-data');
        url.searchParams.set('option_values',[option.id,config.countryId].filter(Boolean).join(','));
        const response=await fetch(url,{credentials:'same-origin'});
        if(!response.ok)throw new Error('Flag options could not load');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const data=html.querySelector('[data-complete-flag-variants]');
        if(!data)throw new Error('Missing monteviera-flag-data section');
        return JSON.parse(data.textContent);
      }));
      const merged=new Map(variants.map(v=>[Number(v.id),v]));
      for(const result of results)if(result.status==='fulfilled')for(const v of result.value)merged.set(Number(v.id),v);
      variants=[...merged.values()];countries=groupCountries(variants);
      renderFlags();await syncCartOffer();
      if(results.some(r=>r.status==='rejected'))console.warn('MONTEVIERA: check monteviera-flag-data.liquid; some flag options failed to load.');
    })();
    updateHolderPositions();
    updateAllHolderVisuals();
    updateFinishControls();
    renderFlags();
    syncCartOffer();
    import('@shopify/events').then(({StandardEvents})=>{
      document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
        event.promise?.then(()=>syncCartOffer()).catch(()=>{});
      });
    }).catch(()=>{});
    window.addEventListener('focus',syncCartOffer);
  };
  const initAll = scope => {
    const roots = scope.matches?.('[data-mvb-section]')
      ? [scope]
      : [...(scope.querySelectorAll?.('[data-mvb-section]') || [])];
    roots.forEach(initBuilder);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
